import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const Footer1 = () => {
  return (
    <footer className="bg-gray-900 text-white py-10">
      <div className="max-w-6xl mx-auto px-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {/* Company Section */}
        <div className="flex flex-col items-center text-center">
          <h3 className="text-lg font-semibold mb-4 text-gray-300">Company</h3>
          <ul className="space-y-2">
            <li><Link to="/about-us" className="text-gray-400 hover:text-white transition">About</Link></li>
            <li><Link to="/contact-us" className="text-gray-400 hover:text-white transition">Contact</Link></li>
            <li><Link to="/blog" className="text-gray-400 hover:text-white transition">Blog</Link></li>
            <li><Link to="/privacy" className="text-gray-400 hover:text-white transition">Privacy Policy</Link></li>
            <li><Link to="/security" className="text-gray-400 hover:text-white transition">Security</Link></li>
          </ul>
        </div>

        {/* Help Section */}
        <div className="flex flex-col items-center text-center">
          <h3 className="text-lg font-semibold mb-4 text-gray-300">Help</h3>
          <ul className="space-y-2">
            <li><Link to="/faqs" className="text-gray-400 hover:text-white transition">FAQs</Link></li>
            <li><Link to="/support" className="text-gray-400 hover:text-white transition">Support</Link></li>
            <li><Link to="/terms" className="text-gray-400 hover:text-white transition">Terms & Conditions</Link></li>
          </ul>
        </div>

        {/* Follow Us Section */}
        <div className="flex flex-col items-center text-center">
          <h3 className="text-lg font-semibold mb-4 text-gray-300">Follow Us</h3>
          <div className="flex space-x-4 justify-center">
            <a href="https://www.facebook.com/jcserviceshub" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition">
              <FaFacebookF size={20} />
            </a>
            <a href="https://x.com/jcshub?lang=en" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-sky-400 transition">
              <FaTwitter size={20} />
            </a>
            <a href="https://www.instagram.com/jcs.hub/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition">
              <FaInstagram size={20} />
            </a>
            <a href="https://www.linkedin.com/company/jcs-hub/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-600 transition">
              <FaLinkedinIn size={20} />
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-10 text-center text-gray-500 text-sm">
        © {new Date().getFullYear()} JCS Global. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer1;
